<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableCloudUserDate"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            v-hasPermission="['monitor:cloudUserMonitor:delete']"
            @click="cloudUserDelmodal = true"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          v-hasPermission="['monitor:cloudUserMonitor:getCloudUserDetailById']"
          @click="rowClick(row)"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal v-model="cloudUserDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ name }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeCloudUser()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableCloudUserVue = {};
export default {
  name: "TableCloudUser",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      cloudUserDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      region: "",
      cloudUserName: "",
      name: "",
      columns: [
        {
          title: this.$t("alarms.cloudUser.title"),
          key: "cloudUserName"
        },
        {
          title: this.$t("alarms.instance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("alarms.instance.accountType"),
          key: "accountTypeName"
        },
        {
          title: this.$t("alarms.instance.region"),
          key: "region"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      tableCloudUserDate: []
    };
  },
  beforeCreate: function() {
    tableCloudUserVue = this;
  },
  mounted: function() {},
  created() {
    eventBus.$on("cloudUserName", function(val) {
      tableCloudUserVue.cloudUserName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableCloudUserVue.companyId = val;
    });
  },
  methods: {
    showAll: function() {
      tableCloudUserVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.resourceCloudUser
        .pageResourceCloudUser({
          pageNum: this.current,
          pageSize: this.pageSize,
          cloudUserName: tableCloudUserVue.cloudUserName,
          companyId: tableCloudUserVue.companyId
        })
        .then(res => {
          this.tableCloudUserDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableCloudUserVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableCloudUserVue.getData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("regionName");
      eventBus.$off("cloudUserName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.name = this.tableCloudUserDate[index].cloudUserName;
    },
    removeCloudUser: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.resourceCloudUser
        .deleteResourceCloudUser("id", this.tableCloudUserDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableCloudUserVue.getData();
            this.isDisable = false;
            this.modal_loading = false;
            this.cloudUserDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/cloudUserDetail/",
        query: {
          id: row.id,
          accountId: row.accountId,
          name: row.cloudUserName,
          region: row.region,
          accountTypeName: row.accountTypeName,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/cloud_user/TableCloudUser.vue